import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompanyMaster } from '../models/auth-response'; // Tu archivo centralizado de interfaces
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SaasService {
  // 🚀 API CORE: Apunta a tu sub-ruta global de administración del servidor
  private apiSaas: string = '/api/saas/companies';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient
  ) {}

  /**
   * 🛡️ METODO AUXILIAR: GENERADOR DE CABECERAS MULTI-TENANT ENTERPRISE
   * Extrae el token de forma segura de la memoria local para satisfacer los filtros
   * de Spring Boot, autorizando el origen cruzado (CORS) y el aislamiento por taller.
   */
  private obtenerCabecerasAduanales(): HttpHeaders {
    let token = '';
    let coId = 'SYSTEM-TENANT-UUID-00000000000000000'; // Fallback basal de infraestructura

    // 💡 SOLUCIÓN: Solo intentamos leer localStorage si estamos ejecutando en el NAVEGADOR
    if (isPlatformBrowser(this.platformId)) {
      const userStr = localStorage.getItem('currentUser');
      if (userStr) {
        const user = JSON.parse(userStr);
        token = user.token || ''; 
        coId = user.coId || coId;  
      }
    }

    const userStr = localStorage.getItem('currentUser');
    if (userStr) {
      const user = JSON.parse(userStr);
      token = user.token || ''; // Extrae tu token JWT si cuentas con él
      coId = user.coId || coId;  // Extrae el coId activo de la sesión del Súper Admin
    }

    return new HttpHeaders({
      'Content-Type': 'application/json',
      // =========================================================================
      // 🚀 HOMOLOGACIÓN DE ADUANAS DE RED: COINCIDENCIA CON TU CORSFILTER DE JAVA
      // Despachamos las firmas exactas que autorizamos en el filtro del Backend.
      // =========================================================================
      'Authorization': `Bearer ${token}`,
      'X-Tenant-ID': coId,
      'x-company-id': coId // Satisface la cabecera exacta de tu log de Angular
    });
  }

  /**
   * 📊 DESCARGA MÁSTER DE INQUILINOS:
   * Recupera la matriz completa de talleres registrados en el ecosistema.
   */
  getCompaniesGlobalList(): Observable<CompanyMaster[]> {
    console.log('>>> [HTTP SAAS] Solicitando catálogo total de inquilinos a Spring Boot...');
    // 💡 Pasamos las cabeceras unificadas en las opciones de la petición
    return this.http.get<CompanyMaster[]>(this.apiSaas, { headers: this.obtenerCabecerasAduanales() });
  }

  /**
   * 🚀 APROVISIONAMIENTO ATÓMICO EN CASCADA:
   * Envía el payload relacional para crear un taller nuevo en MySQL.
   */
  crearNuevaCompania(payload: any): Observable<CompanyMaster> {
    console.log('>>> [HTTP SAAS] Despachando orden de alta masiva para nuevo taller:', payload.nameAlpha);
    return this.http.post<CompanyMaster>(this.apiSaas, payload, { headers: this.obtenerCabecerasAduanales() });
  }

  /**
   * 💾 ACTUALIZACIÓN DE FACULTADES Y SUSCRIPCIÓN:
   * Permite suspender un taller (enabled = false) o ajustar sus datos fiscales JDE.
   */
  actualizarDatosCompania(coId: string, company: CompanyMaster): Observable<CompanyMaster> {
    console.log(`>>> [HTTP SAAS] Aplicando reestructuración en caliente al Tenant ID: ${coId}`);
    return this.http.put<CompanyMaster>(`${this.apiSaas}/${coId}`, company, { headers: this.obtenerCabecerasAduanales() });
  }

   /**
   * 🔍 RECUPERACIÓN AVANZADA BICAPA:
   * Trae del servidor el payload robusto del inquilino cruzando todas sus dimensiones relacionales.
   */
  getCompanyDetails(coId: string): Observable<any> {
    return this.http.get<any>(`${this.apiSaas}/${coId}`, { headers: this.obtenerCabecerasAduanales() });
  }

}